<template>
  <section id="table-component" :class="givenClass">
    <h4>
      {{ title }}
      <b-tooltip label="Copiar al portapapeles" position="is-bottom" class="is-info">
        <button v-if="value.length" class="button is-info is-outlined" @click="copy">
          <span class="icon">
            <i class="fas fa-clipboard fa-lg" />
          </span>
        </button>
      </b-tooltip>
    </h4>
    <b-table
      :id="id"
      :data="data"
      :columns="columns"
      :paginated="paginated"
      :per-page="perPage"
      :bordered="bordered"
      :narrowed="narrowed"
      :mobile-cards="mobileCards"
      :striped="striped"
      :hoverable="hoverable"
      :focusable="focusable"
      :size="size"
      :class="givenClass"
      :sticky-header="stickyHeader" />
  </section>
</template>
<script>
export default {
  props: {
    id: { type: String, default: '' },
    paginated: { type: Boolean, default: false },
    perPage: { type: Number, default: 0 },
    bordered: { type: Boolean, default: false },
    narrowed: { type: Boolean, default: false },
    mobileCards: { type: Boolean, default: true },
    striped: { type: Boolean, default: true },
    hoverable: { type: Boolean, default: true },
    focusable: { type: Boolean, default: false },
    size: { type: String, default: 'is-small' },
    givenClass: { type: String, default: '' },
    stickyHeader: { type: Boolean, default: false },
    value: { type: Array, default: () => [] },
    title: { type: String, default: '' },
    headers: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      columns: [],
      data: []
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val.length < 1) return;
        let headerKeys = Object.keys(this.headers);
        if (!headerKeys.length) {
          headerKeys = Object.keys(val[0]);
        }
        this.columns = headerKeys.map(key => ({
          field: key,
          label: this.headers[key] || key
        }));
        this.data = this.value.map(rowIn => {
          const row = {};
          headerKeys.forEach(key => {
            row[key] = rowIn[key];
          });
          return row;
        });
      }
    }
  },
  mounted() {},
  methods: {
    copy() {
      const lines = [this.columns.map(x => x.label).join('\t')];
      this.data.forEach(row => {
        lines.push(Object.values(row).join('\t'));
      });
      const textToCopy = lines.join('\n');
      this.$copyText(textToCopy).then(result => {
        this.$emit('copySuccess', result);
      }).catch(error => {
        this.$emit('copyError', error);
      });
    }
  }
};
</script>
<style scoped>
  tr,
  thead,
  tbody,
  td {
    text-align: center;
  }
  #table-component h4 {
    display: table-cell;
  }
</style>
